enum ErrorHandled {
  HANDLED,
  NOT_HANDLED,
}

export default ErrorHandled;
